export default {
    indexEventAreas:         { method: 'get',    url: 'event_areas' },
    createEventArea:         { method: 'post',   url: 'event_areas' },
    updateEventArea:         { method: 'put',    url: 'event_areas/{id}' },
    destroyEventArea:        { method: 'delete', url: 'event_areas/{id}' },
}